export default {
    SELECT_DOCUMENT: "Выберите документ для просмотра объектов навигации",
    NO_NAVIGATION_OBJECTS: "Нет объектов навигации",
    FOUND_CONTENT: "Найденные",
    USER_CONTENT: "Загруженные",
    ADD_FOLDER: "Создать папку"
};
